import { render, staticRenderFns } from "./Tikgestion.vue?vue&type=template&id=032dd5f1&scoped=true"
import script from "./Tikgestion.vue?vue&type=script&lang=js"
export * from "./Tikgestion.vue?vue&type=script&lang=js"
import style0 from "./Tikgestion.vue?vue&type=style&index=0&id=032dd5f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032dd5f1",
  null
  
)

export default component.exports